import { DropdownOption } from '@/components/dropdown'
import FullPageTypeahead from '@/components/full-page-typeahead'
import { Drawer, DrawerContent, DrawerHeader } from '@/components/mobile-drawer'
import { Controller, useFormContext } from 'react-hook-form'
import { useStateSearch } from '@/modules/salary/filters/use-state-search'
import {
  getStateOptions,
  stateAlphabeticalSorter,
} from '@/modules/salary/filters/utils'
import { SalaryFilterControls } from '@/modules/salary/types'
import { SalaryFilterControl } from '../../constants'

export function LocationDrawer({
  isOpen,
  onClose,
  selectedLocation,
}: {
  isOpen: boolean
  onClose: () => void
  selectedLocation: DropdownOption | null
}) {
  const { control } = useFormContext<SalaryFilterControls>()
  const { searchState, states } = useStateSearch()
  const fieldName = SalaryFilterControl.state

  const defaultOptions = getStateOptions(states).sort(stateAlphabeticalSorter)
  return (
    <Drawer
      snapPoints={[1]}
      fadeFromIndex={0}
      onClose={onClose}
      open={isOpen}
      direction="right"
    >
      <DrawerContent>
        <DrawerHeader>Location</DrawerHeader>
        <div className="p-4 flex flex-col grow">
          <Controller
            render={({ field: { onChange } }) => {
              return (
                <FullPageTypeahead
                  name={fieldName}
                  searchOptions={searchState}
                  defaultOptions={defaultOptions}
                  defaultQuery={(selectedLocation?.label as string) ?? ''}
                  debounceTimer={300}
                  onClear={() => onChange(null)}
                  onSelect={(option) => {
                    onChange(option)
                    onClose()
                  }}
                />
              )
            }}
            name={fieldName}
            control={control}
          />
        </div>
      </DrawerContent>
    </Drawer>
  )
}
